import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DsLinkColor } from '../../link.interface';

@Component({
  selector: 'ds-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DsLinkComponent {
  @Input() color: DsLinkColor;
}
